/*
 * MNIAMM – wariant "Zupa w prezencie do pierwszego zamówienia" (DEMO)
 * - nie uruchamia się w przeglądarce, z której złożono już zamówienie (znacznik mniamm_has_ordered),
 * - start licznika po pierwszym udanym dodaniu czegokolwiek do koszyka,
 * - od razu nakładamy w tle kod rabatowy (Kup X, dostań Y: 1 zupa z kolekcji promocji za 0 zł),
 * - snackbar z linkiem do listingu zup, plakietka z licznikiem, baner w koszyku,
 * - baner rozpoznaje, czy w koszyku jest już zupa za 0 zł,
 * - po upływie czasu kod znika, a w koszyku zostaje komunikat, że oferta wygasła.
 * - link z kampanii (?zupa=NAZWA) uruchamia ofertę od razu po wejściu – raz na kampanię
 *   (także u osób, którym oferta wcześniej wygasła),
 * - osoby z reklamy widzą własny opis listy zup i własny komunikat „Prawie gotowe!” (ruch naturalny – bez zmian),
 * - adnotacja _promo_zupa w zamówieniu: "TAK – zupa w prezencie jest w zamówieniu" albo "NIE – …".
 * Konfiguracja (czas, kod, kolekcja) w snippets/first-order-promo.liquid.
 */
(function () {
  if (window.MniammPromo) return;

  var config = document.getElementById('MniammPromoConfig');
  if (!config) return;

  // Znacznik "ta przeglądarka złożyła już zamówienie" – ustawia go piksel w panelu
  // (Ustawienia -> Zdarzenia klientów) po zdarzeniu checkout_completed.
  var ORDERED_KEY = 'mniamm_has_ordered';
  function hasOrderedBefore() {
    try { if (window.localStorage.getItem(ORDERED_KEY) === '1') return true; } catch (e) {}
    return document.cookie.split(';').some(function (c) { return c.trim() === ORDERED_KEY + '=1'; });
  }
  if (hasOrderedBefore()) {
    try { console.info('[MniammPromo] ta przeglądarka ma już zamówienie – promocja wyłączona'); } catch (e) {}
    window.MniammPromo = {
      hasOrdered: true,
      reset: function () {
        try { window.localStorage.removeItem(ORDERED_KEY); } catch (e) {}
        document.cookie = ORDERED_KEY + '=; path=/; max-age=0';
        window.location.reload();
      }
    };
    return;
  }

  var STORAGE_KEY = 'mniamm_promo_wybor_v1';
  var DURATION = (parseInt(config.dataset.durationMinutes, 10) || 30) * 60 * 1000;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var DISCOUNT_CODE = config.dataset.discountCode || '';
  var PROMO_URL = config.dataset.promoUrl || ROOT;
  var CART_URL = config.dataset.cartUrl || ROOT + 'cart';
  var CART_TYPE = config.dataset.cartType || 'page';
  var GIFT_PRODUCT_IDS = (config.dataset.giftProductIds || '').split(',').filter(Boolean).map(Number);
  var cartFlag = config.dataset.cartFlag || '';
  var cartCount = parseInt(config.dataset.cartCount, 10) || 0;
  var isCartPage = document.body.classList.contains('template-cart');
  var PROMO_HANDLE = PROMO_URL.split('?')[0].replace(/\/+$/, '').split('/').pop();
  var isPromoListing = !!PROMO_HANDLE && window.location.pathname.indexOf('/collections/' + PROMO_HANDLE) !== -1;

  // Kampania (np. reklama retargetingowa): ?zupa=pazdziernik – nazwa dowolna, max 40 znaków.
  var CAMPAIGN = '';
  try {
    CAMPAIGN = (new URLSearchParams(window.location.search).get('zupa') || '').trim().toLowerCase().slice(0, 40);
  } catch (e) {}

  var originalFetch = window.fetch.bind(window);
  var snackbar = document.getElementById('MniammPromoSnackbar');
  var badge = document.getElementById('MniammPromoBadge');
  var tickHandle = null;
  var hideHandle = null;
  var checking = false;
  // Stan koszyka z ostatniego sprawdzenia: 'none' | 'free' (zupa za 0 zł) | 'needs-more' (sama zupa, rabat nie działa)
  var cartStatus = 'none';

  // Snackbar i plakietka bezpośrednio w <body>, żeby nic ich nie przykrywało.
  if (snackbar && snackbar.parentNode !== document.body) document.body.appendChild(snackbar);
  if (badge && badge.parentNode !== document.body) document.body.appendChild(badge);

  function log(msg) {
    try { console.info('[MniammPromo] ' + msg); } catch (e) {}
  }

  function load() {
    try { return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || null; } catch (e) { return null; }
  }
  function save() {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
  }

  var state = load();

  // Start oferty z linku kampanii: raz na daną kampanię w tej przeglądarce.
  // Aktywnej oferty nie przedłużamy – tylko zapamiętujemy kampanię.
  function applyCampaign() {
    if (!CAMPAIGN) return false;
    var used = (state && state.campaigns) || [];
    if (used.indexOf(CAMPAIGN) !== -1) return false;
    used = used.concat([CAMPAIGN]);
    if (state && Date.now() < state.startedAt + DURATION) {
      state.campaigns = used;
      save();
      return false;
    }
    state = { startedAt: Date.now(), campaigns: used, snackbarShown: isPromoListing, fromCampaign: true };
    save();
    try { console.info('[MniammPromo] start oferty z linku kampanii: ' + CAMPAIGN); } catch (e) {}
    return true;
  }

  // Od razu, zanim cokolwiek się wyrenderuje (teksty dla osób z reklamy).
  var campaignStarted = applyCampaign();

  function endsAt() { return state ? state.startedAt + DURATION : 0; }
  function isActive() { return !!state && Date.now() < endsAt(); }
  function isExpired() { return !!state && Date.now() >= endsAt(); }

  function formatTime(ms) {
    var total = Math.max(0, Math.ceil(ms / 1000));
    var m = Math.floor(total / 60);
    var s = total % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function formatDate(ts) {
    try {
      return new Date(ts).toLocaleString('pl-PL', { timeZone: 'Europe/Warsaw' });
    } catch (e) {
      return new Date(ts).toISOString();
    }
  }

  /* ---------- Koszyk (Ajax API) ---------- */

  function postJSON(path, body) {
    return originalFetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function getCart() {
    return originalFetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function updateCartAttributes(attributes) {
    return postJSON('cart/update.js', { attributes: attributes }).catch(function () {});
  }

  // Adnotacja w zamówieniu: jednoznacznie, czy zupa w prezencie jest w zamówieniu.
  function promoLabel() {
    if (cartStatus === 'free') return 'TAK – zupa w prezencie jest w zamówieniu';
    if (cartStatus === 'needs-more') return 'NIE – zupa bez rabatu (brak innych produktów)';
    return 'NIE – oferta pokazana, zupa nie wybrana';
  }

  function activeAttributes() {
    return {
      _promo_zupa: promoLabel(),
      _promo_zupa_start: formatDate(state.startedAt),
      _promo_zupa_do: formatDate(endsAt())
    };
  }

  function clearedAttributes() {
    return { _promo_zupa: '', _promo_zupa_start: '', _promo_zupa_do: '' };
  }

  // Ostatnio zapisana adnotacja (na start: to, co już jest w koszyku).
  var lastLabel = cartFlag;

  function writeActiveAttributes() {
    lastLabel = promoLabel();
    return updateCartAttributes(activeAttributes());
  }

  function writeClearedAttributes() {
    lastLabel = '';
    return updateCartAttributes(clearedAttributes());
  }

  function sameCode(value) {
    return String(value || '').toUpperCase() === DISCOUNT_CODE.toUpperCase();
  }

  function hasDiscountCode(cart) {
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      if (sameCode(codes[i].code)) return true;
    }
    return false;
  }

  function isGiftProduct(item) {
    return GIFT_PRODUCT_IDS.indexOf(Number(item.product_id)) !== -1;
  }

  // Czy ta pozycja jest obniżona naszym kodem (zupa za 0 zł)?
  function isFreeByOurCode(item) {
    var allocations = item.line_level_discount_allocations || [];
    for (var i = 0; i < allocations.length; i++) {
      var app = allocations[i].discount_application || {};
      if (sameCode(app.title) || sameCode(app.key)) return true;
    }
    var discounts = item.discounts || [];
    for (var j = 0; j < discounts.length; j++) {
      if (sameCode(discounts[j].title)) return true;
    }
    return isGiftProduct(item) && item.original_line_price > 0 && item.final_line_price < item.original_line_price;
  }

  function computeStatus(cart) {
    var hasFree = false;
    var giftUnits = 0;
    var otherUnits = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (isFreeByOurCode(item)) hasFree = true;
      if (isGiftProduct(item)) giftUnits += item.quantity;
      else otherUnits += item.quantity;
    }
    if (hasFree) return 'free';
    // Tylko jedna zupa z promocji i nic więcej – rabat wymaga jeszcze jednego produktu.
    if (giftUnits === 1 && otherUnits === 0) return 'needs-more';
    return 'none';
  }

  function applyDiscountCode(cart) {
    if (!DISCOUNT_CODE || hasDiscountCode(cart)) return Promise.resolve({ changed: false, cart: cart });
    return postJSON('cart/update.js', { discount: DISCOUNT_CODE })
      .then(function () { return getCart(); })
      .then(function (updated) {
        if (hasDiscountCode(updated)) {
          log('nałożono kod rabatowy');
          return { changed: true, cart: updated };
        }
        // Zapasowo: klasyczny link rabatowy (kod trafi do checkoutu przez ciasteczko).
        return originalFetch(ROOT + 'discount/' + encodeURIComponent(DISCOUNT_CODE) + '?redirect=%2Fcart.js', { credentials: 'same-origin' })
          .then(function () {
            log('kod nałożony przez link rabatowy (zapasowo)');
            return getCart();
          })
          .then(function (after) { return { changed: true, cart: after }; });
      });
  }

  function removeDiscountCode() {
    if (!DISCOUNT_CODE) return Promise.resolve();
    return postJSON('cart/update.js', { discount: '' }).catch(function () {});
  }

  // Pilnuje, żeby kod był w koszyku, i sprawdza, czy jest już zupa za 0 zł.
  function syncCart() {
    if (!isActive() || checking) return Promise.resolve(false);
    checking = true;
    var changed = false;

    return getCart()
      .then(function (cart) {
        if (!cart.items.length) return cart;
        return applyDiscountCode(cart).then(function (result) {
          changed = result.changed;
          return result.cart;
        });
      })
      .then(function (cart) {
        var previous = cartStatus;
        cartStatus = computeStatus(cart);
        if (previous !== cartStatus) log('stan koszyka: ' + cartStatus);
        // Aktualizujemy adnotację, gdy zupa pojawi się w koszyku albo z niego zniknie.
        if (promoLabel() !== lastLabel) writeActiveAttributes();
      })
      .catch(function (e) {
        log('błąd: ' + (e && e.message ? e.message : e));
      })
      .then(function () {
        checking = false;
        render();
        if (changed) refreshCart();
        return changed;
      });
  }

  // Odświeża widok koszyka (strona koszyka) bez przeładowania, tak jak robi to motyw.
  function refreshCart() {
    if (!isCartPage) return;
    var itemsEl = document.getElementById('main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');
    if (!itemsEl || !itemsEl.dataset.id) {
      window.location.reload();
      return;
    }
    var sections = [itemsEl.dataset.id, 'cart-icon-bubble'];
    if (footerEl && footerEl.dataset.id) sections.push(footerEl.dataset.id);

    originalFetch(window.location.pathname + '?sections=' + sections.join(','))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var parse = function (html, selector) {
          if (!html) return null;
          var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
          return el ? el.innerHTML : null;
        };
        var itemsHtml = parse(data[itemsEl.dataset.id], '.js-contents');
        var itemsTarget = itemsEl.querySelector('.js-contents');
        if (itemsHtml === null || !itemsTarget) {
          window.location.reload();
          return;
        }
        itemsTarget.innerHTML = itemsHtml;

        if (footerEl && footerEl.dataset.id) {
          var footerHtml = parse(data[footerEl.dataset.id], '.js-contents');
          var footerTarget = footerEl.querySelector('.js-contents');
          if (footerHtml !== null && footerTarget) footerTarget.innerHTML = footerHtml;
        }

        var bubble = document.getElementById('cart-icon-bubble');
        var bubbleHtml = parse(data['cart-icon-bubble'], '.shopify-section');
        if (bubble && bubbleHtml !== null) bubble.innerHTML = bubbleHtml;

        render();
      })
      .catch(function () {
        window.location.reload();
      });
  }

  /* ---------- Widok ---------- */

  function render() {
    var active = isActive();
    var expired = isExpired();
    var text = active ? formatTime(endsAt() - Date.now()) : '0:00';
    // Osoby, którym ofertę uruchomił link z reklamy, widzą osobne teksty (opis listy zup, „Prawie gotowe!”).
    var fromCampaign = active && !!state.fromCampaign;
    var timers = document.querySelectorAll('[data-promo-timer]');
    for (var i = 0; i < timers.length; i++) timers[i].textContent = text;

    var banners = document.querySelectorAll('mniamm-promo-cart');
    for (var j = 0; j < banners.length; j++) {
      var banner = banners[j];
      banner.hidden = !state; // przed startem oferty nic nie pokazujemy
      banner.classList.toggle('is-active', active);
      banner.classList.toggle('is-expired', expired);
      banner.classList.toggle('has-free', active && cartStatus === 'free');
      banner.classList.toggle('needs-more', active && cartStatus === 'needs-more');
      banner.classList.toggle('is-campaign', fromCampaign);
    }

    var descs = document.querySelectorAll('[data-promo-desc]');
    for (var d = 0; d < descs.length; d++) {
      var isCampaignDesc = descs[d].getAttribute('data-promo-desc') === 'campaign';
      descs[d].hidden = isCampaignDesc ? !fromCampaign : fromCampaign;
    }

    if (!active && snackbar) {
      snackbar.classList.remove('is-visible');
      snackbar.hidden = true;
    }
    if (badge) {
      badge.hidden = !active || (snackbar && !snackbar.hidden);
      // Bez zupy w koszyku plakietka prowadzi do listingu zup, z zupą – do koszyka.
      badge.setAttribute('href', cartStatus === 'free' ? CART_URL : PROMO_URL);
    }
  }

  function expire() {
    if (tickHandle) {
      clearInterval(tickHandle);
      tickHandle = null;
    }
    if (!state.cleared) {
      state.cleared = true;
      save();
      log('czas minął – zdejmuję kod rabatowy');
      writeClearedAttributes();
      removeDiscountCode().then(refreshCart);
    }
    cartStatus = 'none';
    render();
  }

  function tick() {
    if (isExpired()) {
      expire();
      return;
    }
    render();
  }

  function startTicking() {
    if (!tickHandle) tickHandle = setInterval(tick, 1000);
    tick();
  }

  function markSnackbarShown() {
    if (state && !state.snackbarShown) {
      state.snackbarShown = true;
      save();
    }
  }

  function hideSnackbar() {
    if (!snackbar) return;
    clearTimeout(hideHandle);
    snackbar.classList.remove('is-visible');
    snackbar.hidden = true;
    markSnackbarShown();
    render();
  }

  function showSnackbar() {
    if (!snackbar || !isActive()) return;
    log('pokazuję snackbar');
    snackbar.hidden = false;
    window.requestAnimationFrame(function () {
      snackbar.classList.add('is-visible');
    });
    render();
    // Za pokazany uznajemy dopiero po zamknięciu lub automatycznym schowaniu –
    // motyw po dodaniu produktu przenosi na /cart, więc snackbar musi przetrwać przeładowanie.
    clearTimeout(hideHandle);
    hideHandle = setTimeout(hideSnackbar, 8000);
  }

  function start() {
    if (state) return; // oferta startuje tylko raz w danej przeglądarce
    state = { startedAt: Date.now() };
    save();
    log('start oferty po dodaniu do koszyka');
    writeActiveAttributes();
    showSnackbar();
    startTicking();
    // Przy koszyku typu "strona" motyw za chwilę przeniesie na /cart – tam dokończymy (init).
    if (CART_TYPE !== 'page' || isCartPage) syncCart();
  }

  function onAddedToCart() {
    if (!state) start();
    else if (isActive() && (CART_TYPE !== 'page' || isCartPage)) syncCart();
    else render();
  }

  var redirecting = false;
  function goToCart() {
    if (redirecting) return;
    redirecting = true;
    log('zupa dodana z listingu – przechodzę do koszyka');
    // Chwila na zapis stanu i odpowiedzi motywu, potem koszyk.
    setTimeout(function () { window.location.href = CART_URL; }, 300);
  }

  // Wyłapujemy każde udane dodanie do koszyka (karta produktu, szybkie dodawanie, inne skrypty używające fetch).
  window.fetch = function (input) {
    var request = originalFetch.apply(window, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/add(\.js)?($|\?)/.test(url)) {
        request.then(function (response) {
          if (!response || !response.ok) return;
          onAddedToCart();
          // Na listingu zup promocji po dodaniu zupy przenosimy od razu do koszyka (tam widać 0 zł).
          if (isPromoListing && isActive()) goToCart();
        }).catch(function () {});
      }
    } catch (e) {}
    return request;
  };

  // Zmiany w koszyku robione przez motyw (usunięcie produktu, zmiana ilości).
  // PUB_SUB_EVENTS to globalna stała motywu (const), więc nie jest dostępna jako window.PUB_SUB_EVENTS.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'product-form') return; // obsługuje to przechwycenie /cart/add
      if (isActive()) syncCart();
    });
  }

  if (!window.customElements.get('mniamm-promo-cart')) {
    window.customElements.define('mniamm-promo-cart', class extends HTMLElement {
      connectedCallback() {
        render();
      }
    });
  }

  if (snackbar) {
    var closeBtn = snackbar.querySelector('[data-promo-close]');
    if (closeBtn) closeBtn.addEventListener('click', hideSnackbar);
    var snackbarLinks = snackbar.querySelectorAll('a');
    for (var l = 0; l < snackbarLinks.length; l++) snackbarLinks[l].addEventListener('click', markSnackbarShown);
    snackbar.addEventListener('mouseenter', function () { clearTimeout(hideHandle); });
    snackbar.addEventListener('mouseleave', function () {
      clearTimeout(hideHandle);
      hideHandle = setTimeout(hideSnackbar, 4000);
    });
  }

  function init() {
    if (campaignStarted) {
      writeActiveAttributes();
      if (!state.snackbarShown) showSnackbar();
      startTicking();
      if (cartCount > 0) syncCart();
      return;
    }
    if (state && isExpired()) {
      if (cartFlag || !state.cleared) {
        state.cleared = true;
        save();
        writeClearedAttributes();
        removeDiscountCode().then(refreshCart);
      }
      render();
      return;
    }
    if (!state) {
      // Oferta startuje wyłącznie po dodaniu produktu do koszyka, nie po wejściu na stronę.
      render();
      return;
    }
    // Oferta aktywna
    if (!cartFlag && cartCount > 0) writeActiveAttributes();
    if (!state.snackbarShown) showSnackbar();
    startTicking();
    if (cartCount > 0) syncCart();
  }

  window.MniammPromo = {
    getState: function () { return { state: state, cartStatus: cartStatus }; },
    reset: function () {
      // tylko do testów: MniammPromo.reset() w konsoli przeglądarki
      try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      try { window.localStorage.removeItem(ORDERED_KEY); } catch (e) {}
      document.cookie = ORDERED_KEY + '=; path=/; max-age=0';
      return removeDiscountCode()
        .then(function () { return updateCartAttributes(clearedAttributes()); })
        .catch(function () {})
        .then(function () { window.location.reload(); });
    }
  };

  init();
})();